/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MeSupplyChainsResponse } from '../../models/me-supply-chains-response';

export interface GetMeSupplyChains$Params {
}

export function getMeSupplyChains(http: HttpClient, rootUrl: string, params?: GetMeSupplyChains$Params, context?: HttpContext): Observable<StrictHttpResponse<MeSupplyChainsResponse>> {
  const rb = new RequestBuilder(rootUrl, getMeSupplyChains.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MeSupplyChainsResponse>;
    })
  );
}

getMeSupplyChains.PATH = '/me/supply-chains';
